import { render, staticRenderFns } from "./ParticipantClaimsTabItem.vue?vue&type=template&id=4660a3bf&scoped=true"
import script from "./ParticipantClaimsTabItem.vue?vue&type=script&lang=js"
export * from "./ParticipantClaimsTabItem.vue?vue&type=script&lang=js"
import style0 from "./ParticipantClaimsTabItem.vue?vue&type=style&index=0&id=4660a3bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660a3bf",
  null
  
)

export default component.exports